import Vue from "vue";
import VueMeta from "vue-meta";
import objectFitImages from "object-fit-images";

import socialIcons from "@/constants/socialIcons";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

objectFitImages();
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.use(socialIcons);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
